import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal, Spin, Tabs} from "antd";
import {t} from "i18next";
import { LoadingOutlined } from '@ant-design/icons';
import {getNoteList, getSearchNoteList} from "@model/note";
import {getAllCardList, getCardList} from "@model/card";
import {getImagePathSvg, getImagePathWithTheme, isAnnoElement, isAnnoType, isDarkMode} from "@/utils";
import GlobalSearchItem from "@/views/Dialog/components/GlobalSearchItem";
import Spinner from "../../../@excalidraw/packages/excalidraw/components/Spinner";
import global from "@/global";
import '../../components/EditorV2/SmallEditStyle.css'
import {resetRootPostionNormal} from "@/Utility0";
import {atomCardItemPointerEvent} from "@/views/Home/HomeIndex";
import {atomPointerEvents} from "@/components/Pdf/compoents/FileModal";
import {useAtom} from "jotai";

const DialogGlobalSearch = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const [inputUrl,setInputUrl] = useState('');
    const [tabKey,setTabKey] = useState('all');
    const inputRef = useRef(null);
    const [datas,setDatas] = useState({arrayAll:[],arrayProjects:[],arrayCards:[],arrayPdfs:[],arrayJournals:[],arrayImages:[],arrayVideos:[],arrayFiles:[],arrayHighlights:[]})
    const mDatas = useRef<any>(null);
    const nTimeoutId = useRef<any>(0);
    const [isSearching,setIsSearching] = useState(false);
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    const [isPin,setIsPin] = useState(false);
    const [hasMaskLayer,setHasMaskLayer] = useState(window.getDialogPinCount() == 0);
    //拖拽
    const mIsDragging = useRef<any>(false);
    const offset = useRef<any>({x:0,y:0});

    const nWidth = 900;
    const nHeight = 600;
    const mResizing = useRef(null);
    const [x, setX] = useState((document.body.clientWidth-nWidth)*0.5); // div 的左上角 x 坐标
    const [y, setY] = useState((document.body.clientHeight - nHeight)*0.5); // div 的左上角 y 坐标
    // const [resizing, setResizing] = useState(null); // 当前正在拖拽的角

    const initialMousePos = useRef<any>({ x: 0, y: 0});
    const [dialogSize,setDialogSize] = useState<any>({width:nWidth,height:nHeight});
    const [pointerEvents,setPointerEvents] = useAtom(atomPointerEvents);
    const [cardItemPointerEvent,setCardItemPointerEvent] = useAtom(atomCardItemPointerEvent);

    const globalSearchItemRef = useRef(null);
    const draggleRef = useRef(null);

    const tabItems = [
        {
            key:'all',
            label:t('All'),
            children:''
        },
        {
            key:'project',
            label:t('Projects'),
            children:''
        },
        {
            key:'card',
            label:t('Card'),
            children:''
        },
        {
            key:'pdf',
            label:t('PDF'),
            children:''
        },
        {
            key:'journal',
            label:t('Journal'),
            children:''
        },
        {
            key:'image',
            label:t('Image'),
            children:''
        },
        {
            key:'video',
            label:t('Video'),
            children:''
        },
        {
            key:'file',
            label:t('File'),
            children:''
        },
        {
            key:'highlight',
            label:t('Highlights'),
            children:''
        },
    ]

    const onShowDialog = ()=>{
        setIsShowDialog(true)
    }

    useEffect(() => {
        setTimeout(()=>{
            inputRef.current?.focus();
        },100);

        // refreshData('');

        //添加要刷新列表...
        window.refreshList['globalSearchItem'] = onRefreshData;
        global.g_showDialogs.dialogGlobalSearch = true;

        //page 和 journal 中有处理root的position问题。所以这里要强制再设置一次。暂时忽略pagecard和journal中的搜索问题.
        // resetRootPostionNormal();

        document.body.addEventListener('mousemove',handleMouseMove);
        document.body.addEventListener('mouseup',handleMouseUp);

        //刷新主题
        window.refreshList['updateTheme_globalSearch'] = ()=>{
            forceUpdate();
        };

        return ()=>{
            delete window.refreshList['globalSearchItem'];
            global.g_showDialogs.dialogGlobalSearch = false;
            document.body.removeEventListener('mousemove',handleMouseMove);
            document.body.removeEventListener('mouseup',handleMouseUp);
        }
    }, []);

    useEffect(() => {
        window.isGlobalSearchPin = ()=>{
            return isPin;
        }

        return ()=>{
            delete window.isGlobalSearchPin;
        }
    }, [isPin]);

    const handleMouseDown = (corner) => (e) => {
        mResizing.current = (corner);
        initialMousePos.current = ({ x: e.clientX, y: e.clientY });
        setPointerEvents('none');
        e.preventDefault();
        e.stopPropagation();
    };

    const handleMouseMove = (e) => {
        if (mResizing.current){
            e.stopPropagation();
            setPointerEvents('none');
            setCardItemPointerEvent('none');

            const rect = draggleRef.current.getBoundingClientRect();
            const deltaX = e.clientX - initialMousePos.current.x;
            const deltaY = e.clientY - initialMousePos.current.y;
            let nWidth = 0,nHeight =0;

            switch (mResizing.current) {
                case 'top-left':
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setX(rect.left + deltaX);
                    setY(rect.top + deltaY);
                    break;
                case 'top-right':
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setY(rect.top + deltaY);
                    break;
                case 'bottom-left':
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    setX(rect.left + deltaX);
                    break;
                case 'bottom-right':
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    break;
                case "left":
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = rect.height;
                    setX(rect.left + deltaX);
                    break;
                case "top":
                    nWidth = rect.width;
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setY(rect.top + deltaY);
                    break;
                case "right":
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = rect.height;
                    break;
                case "bottom":
                    nWidth = rect.width;
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    break;
                default:
                    break;
            }

            if (nWidth < 580){
                nWidth = 580;
            }
            if (nHeight < 600){
                nHeight = 600;
            }

            setDialogSize({
                width: nWidth,
                height: nHeight,
                maxHeight: '100vh'
            })

            initialMousePos.current = ({ x: e.clientX, y: e.clientY });
        }

        if (mIsDragging.current) {
            setX(e.clientX - offset.current.x);
            setY(e.clientY - offset.current.y);
        }
    };

    const handleMouseUp = () => {
        mResizing.current = (null);
        setPointerEvents('all');
        setCardItemPointerEvent('all');
    };

    const getIsPin = ()=>{
        return isPin;
    }

    const onRefreshData = ()=>{
        refreshData(inputRef.current?.value?.toLowerCase())
    }

    /**
     * 刷新数据
     */
    const refreshData = async (szSearch:any)=>{
        if (!szSearch){
            setDatas({arrayAll:[],arrayProjects:[],arrayCards:[],arrayPdfs:[],arrayJournals:[],arrayImages:[],arrayVideos:[],arrayFiles:[],arrayHighlights:[]});
            setIsSearching(false);
            return;
        }

        let arrayProjects:any = null;
        if (szSearch){
            szSearch = szSearch.trim();
            arrayProjects = await getSearchNoteList(szSearch,true);
        }else{
            arrayProjects = await getNoteList();
        }
        let arrayLibrary:any = await getAllCardList(szSearch);

        arrayProjects.sort((a,b)=>{
            if (!a.updateTime || !b.updateTime)return 0;
            return b.updateTime - a.updateTime;
        })
        arrayProjects.forEach(p=>{
            p.type = 'project'
        })

        arrayLibrary.sort((a,b)=>{
            if (!a.updateTime || !b.updateTime)return 0;
            return b.updateTime - a.updateTime;
        })

        //再处理一遍---标题包含关键字的话在最前面...
        let arrayIncludeTitles:any = [];
        for (let i=0;i<arrayProjects.length;i++){
            const proj = arrayProjects[i];
            if (proj.name?.toLowerCase()?.includes(szSearch)){
                arrayIncludeTitles.push(proj);
            }
        }
        arrayIncludeTitles.sort((a,b)=>{
            return a.name.localeCompare(b.name);
        })
        const arrayNewNewProject:any = [...arrayIncludeTitles];
        for (let i=0;i<arrayProjects.length;i++){
            const proj = arrayProjects[i];
            if (!arrayIncludeTitles.some(p=>p.id == proj.id)){
                arrayNewNewProject.push(proj);
            }
        }
        arrayProjects = arrayNewNewProject;
        //end project--

        //library标题的优先--不包含注记.---
        arrayIncludeTitles = [];
        for (let i=0;i<arrayLibrary.length;i++){
            const library = arrayLibrary[i];
            if (isAnnoType(library.type))continue;
            if (library.name?.toLowerCase()?.includes(szSearch)){
                arrayIncludeTitles.push(library);
            }
        }
        arrayIncludeTitles.sort((a,b)=>{
            return a.name.localeCompare(b.name);
        })
        const arrayNewNewLibrary:any = [...arrayIncludeTitles];
        for (let i=0;i<arrayLibrary.length;i++){
            const library = arrayLibrary[i];
            if (!arrayIncludeTitles.some(p=>p.id == library.id)){
                arrayNewNewLibrary.push(library);
            }
        }
        arrayLibrary = arrayNewNewLibrary;
        //end library

        let arrayAll:any = [];
        arrayAll.push(...arrayProjects);
        arrayAll.push(...arrayLibrary);

        arrayAll.sort((a,b)=>{
            if (!a.updateTime || !b.updateTime)return 0;
            return b.updateTime - a.updateTime;
        })

        //同样的处理一遍arrayAll---
        arrayIncludeTitles = [];
        for (let i=0;i<arrayAll.length;i++){
            const all = arrayAll[i];
            if (isAnnoType(all.type))continue;
            if (all.name?.toLowerCase()?.includes(szSearch)){
                arrayIncludeTitles.push(all);
            }
        }
        arrayIncludeTitles.sort((a,b)=>{
            return a.name.localeCompare(b.name);
        })
        const arrayNewNewAll:any = [...arrayIncludeTitles];
        for (let i=0;i<arrayAll.length;i++){
            const library = arrayAll[i];
            if (!arrayIncludeTitles.some(p=>p.id == library.id)){
                arrayNewNewAll.push(library);
            }
        }
        arrayAll = arrayNewNewAll;
        //end all

        const arrayCards = arrayLibrary.filter(p=>p.type == 'card');
        const arrayJournals = arrayLibrary.filter(p=>p.type == 'journal');
        const arrayPdfs = arrayLibrary.filter(p=>p.type == 'pdf');
        const arrayImages = arrayLibrary.filter(p=>p.type == 'image');
        const arrayVideos = arrayLibrary.filter(p=>p.type == 'liveVideo' || p.type == 'video' || p.type == 'bilibili' || p.type == 'youtube' || p.type == 'baidu');
        const arrayFiles = arrayLibrary.filter(p=>p.type == 'file');
        const arrayHighlights = arrayLibrary.filter(p=>isAnnoType(p.type));

        mDatas.current = {
            arrayAll,
            arrayProjects,
            arrayCards,
            arrayPdfs,
            arrayJournals,
            arrayImages,
            arrayVideos,
            arrayFiles,
            arrayHighlights
        }
        setDatas(mDatas.current);

        setTimeout(()=>{
            setIsSearching(false);
        },100)
    }

    const onInputChanged = (e)=>{
        let szSearch = e.currentTarget.value;
        setInputUrl(szSearch);
        setIsSearching(true);
        clearTimeout(nTimeoutId.current);

        nTimeoutId.current = setTimeout(()=>{
            globalSearchItemRef.current?.resetPreview();
            refreshData(szSearch.toLowerCase());
        },1200)
    }

    const onTabChanged = (activeKey:any)=>{
        setTabKey(activeKey);
    }

    /**
     * 渲染页面
     */
    const renderPages = ()=>{
        return<>
            {
                tabKey == 'all' &&
                <GlobalSearchItem ref={globalSearchItemRef} arrayDatas={datas.arrayAll} searchKey={inputUrl} isSearching={isSearching}/>
            }
            {
                tabKey == 'project' &&
                <GlobalSearchItem ref={globalSearchItemRef} arrayDatas={datas.arrayProjects} searchKey={inputUrl} isSearching={isSearching}/>
            }
            {
                tabKey == 'card' &&
                <GlobalSearchItem ref={globalSearchItemRef} arrayDatas={datas.arrayCards} searchKey={inputUrl} isSearching={isSearching}/>
            }
            {
                tabKey == 'pdf' &&
                <GlobalSearchItem ref={globalSearchItemRef} arrayDatas={datas.arrayPdfs} searchKey={inputUrl} isSearching={isSearching}/>
            }
            {
                tabKey == 'journal' &&
                <GlobalSearchItem ref={globalSearchItemRef}  arrayDatas={datas.arrayJournals} searchKey={inputUrl} isSearching={isSearching}/>
            }
            {
                tabKey == 'image' &&
                <GlobalSearchItem ref={globalSearchItemRef}  arrayDatas={datas.arrayImages} searchKey={inputUrl} isSearching={isSearching}/>
            }
            {
                tabKey == 'video' &&
                <GlobalSearchItem ref={globalSearchItemRef}  arrayDatas={datas.arrayVideos} searchKey={inputUrl} isSearching={isSearching}/>
            }
            {
                tabKey == 'file' &&
                <GlobalSearchItem ref={globalSearchItemRef}  arrayDatas={datas.arrayFiles} searchKey={inputUrl} isSearching={isSearching}/>
            }
            {
                tabKey == 'highlight' &&
                <GlobalSearchItem ref={globalSearchItemRef} arrayDatas={datas.arrayHighlights} searchKey={inputUrl} isSearching={isSearching}/>
            }
        </>
    }

    return <Modal
        keyboard = {!isPin} zIndex={1000}
                  width={dialogSize.width+'px'}
        mask={hasMaskLayer}
                  style={{
                      minWidth: (dialogSize.width)+'px',
                      margin:'0px',
                      left:x+'px',
                      top:y+'px',
                      paddingBottom:'0px',
                      position:'fixed'
                  }}
                  styles={{
                      wrapper: {
                          overflow: "hidden",
                          borderRadius: 0,
                          pointerEvents:isPin?'none':'all',
                      },
                      content: {
                          width: (dialogSize.width)+'px',
                          height: dialogSize.height + "px",
                          borderRadius:10,

                      }
                  }}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={isShowDialog} centered={true} closable={false} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}
        modalRender={(modal) => (
        <div className={'div-no-margin'} id={'drag-global-search'} ref={draggleRef} onMouseDown={(event) => {
            event.stopPropagation();
            if (!getIsPin())return;

            mIsDragging.current = true;
            offset.current.x = event.clientX - draggleRef.current.getBoundingClientRect().left;
            offset.current.y = event.clientY - draggleRef.current.getBoundingClientRect().top;
            setPointerEvents('none');
        }} onMouseMove={(event) => {
            if (mIsDragging.current) {
                setX(event.clientX - offset.current.x);
                setY(event.clientY - offset.current.y);
            }
        }} onMouseUp={(event) => {
            mIsDragging.current = false;
            setPointerEvents('all');
        }} style={{}} onClick={(event) => {
            event.stopPropagation();
            // window.bringDialogPdfFront({fileId});
        }}>
            {modal}

            {/* 四个拖拽手柄 */}
            {
                getIsPin() &&
                <>
                    <div className="resize-handle top-left" onMouseDown={handleMouseDown('top-left')}/>
                    <div className="resize-handle top-right" onMouseDown={handleMouseDown('top-right')}/>
                    <div className="resize-handle bottom-left" onMouseDown={handleMouseDown('bottom-left')}/>
                    <div className="resize-handle bottom-right" onMouseDown={handleMouseDown('bottom-right')}/>
                    <div className="resize-handle left" onMouseDown={handleMouseDown('left')}/>
                    <div className="resize-handle right" onMouseDown={handleMouseDown('right')}/>
                    <div className="resize-handle top" onMouseDown={handleMouseDown('top')}/>
                    <div className="resize-handle bottom" onMouseDown={handleMouseDown('bottom')}/>
                </>
            }

            {/* 你的内容 */}
        </div>
    )}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{width:'100%'}}>
                <div className='input-border-5f flex-row-vertical-center'
                     style={{
                         margin: '0px -6px',
                         background: 'var(--input-background-color-EFEFEF)!important',
                         flexShrink: '0',
                         flexGrow:'1',
                     }}>
                    <input ref={inputRef} style={{
                        marginTop: '0px',
                        border: 'none',
                        outline: 'none',
                        flexGrow: '1',
                        paddingLeft: '8px',
                        background: 'transparent'
                    }} className='font-family-regular font-size-12'
                           onKeyDown={(event) => {
                               event.stopPropagation();
                           }}
                           onChange={onInputChanged} placeholder={t("Search")} value={inputUrl}/>
                    {
                        isSearching &&
                        <Spin indicator={<img className={'img-16 rotating-image'}
                                              src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
                    }

                </div>

                <img className={'img-16 cursor-pointer ml-22'}
                     src={isPin?getImagePathWithTheme('dialog_pin_no_padding.svg'):getImagePathWithTheme('dialog_unpin_no_padding.svg')} onClick={(e)=>{
                         setIsPin(!isPin)
                    setHasMaskLayer(isPin)
                }}/>
                <img className={'img-16 cursor-pointer ml-16'} src={getImagePathWithTheme('ic_close_no_padding.svg')} onClick={(e)=>{
                    props.onCloseCallback();
                }}/>
            </div>


            <ConfigProvider
                theme={{
                    components: {
                        Tabs: {
                            /* 这里是你的组件 token */
                            fontSize: 12
                        },
                    },
                }}
            >
                <Tabs style={{margin: '12px -8px 0px -8px'}} tabBarStyle={{paddingLeft: '10px'}}
                      className='font-size-12' items={tabItems} activeKey={tabKey} onChange={onTabChanged}/>
            </ConfigProvider>

            <div style={{paddingTop: '0px', height: '494px', marginLeft: '-6px'}}>
                {renderPages()}
            </div>
        </div>
    </Modal>
})

export default DialogGlobalSearch;




























